import PasswordResetPanel from "./PasswordResetPanel";

export default PasswordResetPanel;